import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import PrimaryButton from '../button/primaryButton'
import EmailPhoneCombine from '../fields/emailPhoneField'
import { useDispatch, useSelector } from 'react-redux'
import { sendCompanyInvitationApi } from '../../../service/api/companies/sendCompanyInvitation'
import { emailValidation, noSpaceOnChange, phoneValidation } from '../../../validations/validation'
import { errEmptyEmailOrPhone } from '../../../dataBaseFile/error'
import { validEmail_OR_MobileNumberText } from '../../../dataBaseFile/label'
import ResponceToaster from '../responceToaster/responceToaster'

const InviteProModal = ({
    inviteProTrigger,
    handleCloseInviteProModal,
}) => {
    const { permissionArr, impersonateFlag, companyId } = useSelector((state) => state.user);
    const dispatch = useDispatch();

    const [isEmailPhoneVal, setIsEmailPhoneVal] = useState(false);
    const [emailPhoneValue, setEmailPhoneValue] = useState("");
    const [codeValue, setCodeValue] = useState(1);
    const [isPhone, setIsPhone] = useState(false);
    const [loginErrorMsg, setLoginErrorMsg] = useState("");

    const [loaderActive, setLoaderActive] = useState(false)
    const [handleToaster, setHandleToaster] = useState(false);
    const [toasterType, setToasterType] = useState();
    const [resMessage, setResMessage] = useState("");

    const handleAddTeamMemberByAdmin = () => {
        // const data = new FormData();
        // data.append("company_id_ids", companyId);
        // data.append("email_chr", email);
        // data.append("phone_code_id_int", countryCode || 0);
        // data.append("phone_number_int", phonenumber || 0);
        // data.append("role_id_ids", parseInt(roleUser));

        if (isPhone) {
            const data = new FormData();
            data.append("company_id_ids", companyId);
            data.append("email_chr", '');
            data.append("phone_code_id_int", codeValue || 0);
            data.append("phone_number_int", emailPhoneValue || 1);
            data.append("role_id_ids", 1);

            dispatch(sendCompanyInvitationApi(data, (res) => {
                setToasterType("success")
                setResMessage(res.data.message);
                setHandleToaster(true);
                setTimeout(() => {
                    setHandleToaster(false);
                }, 11000);
                handleCloseInviteProModal()

            }, (res) => {
                setToasterType("error")
                setResMessage(res.data.message);
                setHandleToaster(true);
                setTimeout(() => {
                    setHandleToaster(false);
                }, 11000);
                setLoaderActive(false)
            }))

        } else {
            const data = new FormData();
            data.append("company_id_ids", companyId);
            data.append("email_chr", emailPhoneValue);
            // data.append("phone_code_id_int", codeValue || 0);
            // data.append("phone_number_int", emailPhoneValue || 0);
            data.append("role_id_ids", 1);

            dispatch(sendCompanyInvitationApi(data, (res) => {
                setToasterType("success")
                setResMessage(res.data.message);
                setHandleToaster(true);
                setTimeout(() => {
                    setHandleToaster(false);
                }, 11000);
                handleCloseInviteProModal()

            }, (res) => {
                setToasterType("error")
                setResMessage(res.data.message);
                setHandleToaster(true);
                setTimeout(() => {
                    setHandleToaster(false);
                }, 11000);
                setLoaderActive(false)
            }))
        }
    }

    const handleSubmit = (e) => {
        e?.preventDefault();
        if (!isPhone) {
            if (!emailValidation(emailPhoneValue)) {
                setIsEmailPhoneVal(true);
                if (emailPhoneValue === "") {
                    setIsEmailPhoneVal(true);
                    setLoginErrorMsg(errEmptyEmailOrPhone);
                } else if (!phoneValidation(emailPhoneValue)) {
                    setIsEmailPhoneVal(true);
                    setLoginErrorMsg(validEmail_OR_MobileNumberText);
                }
            }
        } else {
            if (!phoneValidation(emailPhoneValue)) {
                setIsEmailPhoneVal(true);
                if (emailPhoneValue === "") {
                    setIsEmailPhoneVal(true);
                    setLoginErrorMsg(errEmptyEmailOrPhone);
                } else if (!emailValidation(emailPhoneValue)) {
                    setIsEmailPhoneVal(true);
                    setLoginErrorMsg(validEmail_OR_MobileNumberText);
                }
            }
        }

        if ((!isPhone ? emailValidation(emailPhoneValue) : phoneValidation(emailPhoneValue))) {
            setLoaderActive(true)
            handleAddTeamMemberByAdmin();
        }
    }

    useEffect(() => {
        const dot = ".";
        const leng = emailPhoneValue.length - 1;
        if (!isNaN(emailPhoneValue) && emailPhoneValue.charAt(leng) !== dot) {
            if (emailPhoneValue.length < 11) {
                setIsPhone(true);
            } else {
                setIsPhone(false);
            }
        } else {
            setIsPhone(false);
        }
        if (emailPhoneValue === "") {
            setIsPhone(false);
        }
    }, [emailPhoneValue]);

    const handleEmailPhone = (e) => {
        // console.log(e.target.value);
        setIsEmailPhoneVal(false);
        noSpaceOnChange(e.target.value) && setEmailPhoneValue(e.target.value);

    };

    const handleDropdownValue = (e) => {
        // setCodeValue(e.target.value);
        setCodeValue(e);

    };

    function handleBlur() {
        if (isPhone) {
            if (emailPhoneValue === "") {
                setIsEmailPhoneVal(true);
                setLoginErrorMsg(errEmptyEmailOrPhone);
            } else if (!phoneValidation(emailPhoneValue)) {
                setIsEmailPhoneVal(true);
                setLoginErrorMsg(validEmail_OR_MobileNumberText);
            }
        } else {
            if (emailPhoneValue === "") {
                setIsEmailPhoneVal(true);
                setLoginErrorMsg(errEmptyEmailOrPhone);
            } else if (!emailValidation(emailPhoneValue)) {
                setIsEmailPhoneVal(true);
                setLoginErrorMsg(validEmail_OR_MobileNumberText);
            }
        }
    }

    return (
        <>
            {/* <!-- Modal --> */}
            < Modal
                className="fade"
                show={inviteProTrigger}
                // onHide={handleCloseAddUser}
                centered
            >
                < Modal.Body >
                    <div className="row mx-0">
                        <div className="col-12 px-0">

                            <div className='mx-0 row'>
                                <div className='col-12 d-flex fs-4 justify-content-end px-0 text-black'>
                                    <span onClick={() => handleCloseInviteProModal()} className='cursor-pointer'>
                                        <i className="bi bi-x-lg"></i>
                                    </span>
                                </div>
                            </div>

                            <div className='mx-0 row mb-4 pb-2 '>
                                <div className='col-12 font-w600 fs-3 px-0 text-center text-black '>
                                    <span>
                                        {"Send company invitation"}
                                    </span>
                                </div>
                            </div>

                            <div className='mx-0 row mb-4 pb-2 '>
                                <div className='col-12  fs-5 px-0 text-center'>
                                    <span>
                                        {"Enter an email or phone number to send company invitation"}
                                    </span>
                                </div>
                            </div>

                            <form onSubmit={handleSubmit}>
                                <div className="row mb-2">
                                    <EmailPhoneCombine
                                        isEnteringNumber={isPhone}
                                        setIsEnteringNumber={setIsPhone}
                                        handleInputValue={handleEmailPhone}
                                        handleChangeCode={handleDropdownValue}
                                        errorOccured={isEmailPhoneVal}
                                        inputValue={emailPhoneValue}
                                        handleOnBlur={handleBlur}
                                        defaultCodeValue={codeValue}
                                        errorMessage={
                                            // validEmail_OR_MobileNumberText
                                            loginErrorMsg
                                        }
                                        isRequired={true}
                                    />
                                </div>

                                <div className="d-flex align-items-center justify-content-center">
                                    <PrimaryButton
                                        onClick={handleSubmit}
                                        buttonName={`SEND INVITE`}
                                        isLoading={loaderActive}
                                        loadingMessage={"SENDING"}
                                        style={{
                                            width: '100%',
                                            border: 'none',
                                            background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                                            boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                                        }}
                                    />
                                </div>
                            </form>
                        </div>
                    </div>
                </Modal.Body >
            </Modal >

            {handleToaster && <ResponceToaster toasterType={toasterType} message={resMessage} />}
        </>
    )
}

export default InviteProModal